/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PersonUpdateWithPermissionsRequest model module.
 * @module model/PersonUpdateWithPermissionsRequest
 * @version v0
 */
export default class PersonUpdateWithPermissionsRequest {
  /**
   * Constructs a new <code>PersonUpdateWithPermissionsRequest</code>.
   * @alias module:model/PersonUpdateWithPermissionsRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PersonUpdateWithPermissionsRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PersonUpdateWithPermissionsRequest} obj Optional instance to populate.
   * @return {module:model/PersonUpdateWithPermissionsRequest} The populated <code>PersonUpdateWithPermissionsRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PersonUpdateWithPermissionsRequest();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('firstname'))
        obj.firstname = ApiClient.convertToType(data['firstname'], 'String');
      if (data.hasOwnProperty('lastname'))
        obj.lastname = ApiClient.convertToType(data['lastname'], 'String');
      if (data.hasOwnProperty('permissions'))
        obj.permissions = ApiClient.convertToType(data['permissions'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
PersonUpdateWithPermissionsRequest.prototype.id = undefined;

/**
 * @member {String} email
 */
PersonUpdateWithPermissionsRequest.prototype.email = undefined;

/**
 * @member {String} firstname
 */
PersonUpdateWithPermissionsRequest.prototype.firstname = undefined;

/**
 * @member {String} lastname
 */
PersonUpdateWithPermissionsRequest.prototype.lastname = undefined;

/**
 * @member {String} permissions
 */
PersonUpdateWithPermissionsRequest.prototype.permissions = undefined;

